import type { WhatsappGroupsTranslations } from '../interfaces/whatsappGroups';

export const whatsappGroupsTranslations: WhatsappGroupsTranslations = {
  page_title: 'WhatsApp Groups',
  page_subtitle:
    "Create groups on {{brand}}'s number, share the invite link and assign an AI agent to each group (max 8 participants).",
  new_group: 'New group',
  search_placeholder: 'Search by name…',
  empty_title: 'No groups yet',
  empty_description:
    'Create your first WhatsApp group and share its invite link.',
  members_badge: '{{count}}/8 members',
  suspended_badge: 'Suspended',
  agent_badge_active: 'Agent active',
  agent_badge_paused: 'Agent paused',
  agent_badge_none: 'No agent',
  row_copy_link: 'Copy link',
  row_view: 'View group',
  row_delete: 'Delete',
  delete_confirm_title: 'Delete group',
  delete_confirm_description:
    'The group will be deleted on WhatsApp for all its members. This cannot be undone.',
  delete_confirm_cta: 'Delete',
  link_copied: 'Link copied to clipboard',
  no_invite_link: 'No invite link',

  create_title: 'New group',
  create_subtitle:
    "The group is created on {{brand}}'s verified number. Members join through the invite link.",
  form_subject_label: 'Group name',
  form_subject_placeholder: 'e.g. VIP customers',
  form_subject_required: 'Name is required',
  form_subject_too_long: 'Max 128 characters',
  form_description_label: 'Description',
  form_description_placeholder: 'Optional group description…',
  form_description_too_long: 'Max 2048 characters',
  form_approval_label: 'Joining the group',
  approval_required_label: 'Approval required',
  approval_required_description:
    'Every join request must be approved manually.',
  auto_approve_label: 'Auto approve',
  auto_approve_description:
    'Anyone with the link joins directly (until the group is full).',
  form_agent_label: 'AI agent (optional)',
  form_agent_placeholder: 'Select an agent…',
  form_agent_none: 'No agent',
  create_submit: 'Create group',
  create_success: 'Group created successfully',

  back_to_list: 'Back to groups',
  suspended_banner:
    'Meta suspended this group. The agent will not reply and no changes are possible until the suspension is lifted.',
  tab_members: 'Members',
  tab_requests: 'Requests',
  tab_agent: 'Agent',
  tab_settings: 'Settings',

  invite_title: 'Invite link',
  invite_description:
    'Share it with the people you want in the group. Joining is only possible through this link.',
  invite_copy: 'Copy',
  invite_reset: 'Generate new link',
  invite_reset_confirm_title: 'Generate a new link?',
  invite_reset_confirm_description:
    'The current link will stop working. You will need to share the new one.',

  members_title: 'Group members',
  members_empty: 'No members yet. Share the invite link.',
  member_remove: 'Remove',
  member_remove_confirm_title: 'Remove from group',
  member_remove_confirm_description:
    'This person will leave the group. They can rejoin with a valid invite link.',
  member_joined_at: 'Joined {{date}}',

  requests_title: 'Join requests',
  requests_empty: 'No pending requests.',
  request_approve: 'Approve',
  request_reject: 'Reject',
  request_status_pending: 'Pending',
  request_status_approved: 'Approved',
  request_status_rejected: 'Rejected',
  request_status_revoked: 'Revoked',

  agent_title: 'AI agent',
  agent_description:
    'The assigned agent automatically replies to messages in this group.',
  agent_select_placeholder: 'Select an agent…',
  agent_save: 'Save',
  agent_pause: 'Pause',
  agent_resume: 'Resume',
  agent_unbind: 'Remove agent',
  agent_unbind_confirm_title: 'Remove the agent from this group',
  agent_unbind_confirm_description:
    'The agent will stop replying in this group. You can assign another one anytime.',
  agent_none_hint: 'This group has no agent assigned.',

  settings_title: 'Group settings',
  settings_save: 'Save changes',
  settings_delete_title: 'Delete group',
  settings_delete_description:
    'Deletes the group on WhatsApp for all its members.',

  cancel: 'Cancel',
  confirm: 'Confirm',
  saved: 'Changes saved',
  error_generic: 'Something went wrong. Please try again.',
};
